import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0",
    {
        variants: {
            variant: {
                default:
                    'bg-primary text-primary-foreground shadow hover:bg-primary/90 active:bg-primary/80',
                destructive:
                    'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90 active:bg-destructive/80',
                destructiveOutline:
                    'border border-red-300 bg-background text-destructive shadow-sm hover:bg-red-50 hover:text-red-800 active:bg-red-100',
                outline:
                    'border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground active:bg-neutral-100',
                secondary:
                    'bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80 active:bg-neutral-100',
                ghost: 'hover:bg-accent hover:text-accent-foreground active:bg-neutral-100',
                link: 'text-primary underline-offset-4 hover:underline',
            },
            size: {
                default: 'h-9 px-4 py-2 [@media(pointer:coarse)]:min-h-11',
                sm: 'h-8 rounded-md px-3 text-xs [@media(pointer:coarse)]:min-h-11',
                lg: 'h-10 rounded-md px-8 [@media(pointer:coarse)]:min-h-11',
                icon: 'h-9 w-9 shrink-0 [@media(pointer:coarse)]:min-h-11 [@media(pointer:coarse)]:min-w-11',
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
        },
    },
);
